import { Modifier } from '@popperjs/core';

export const sameWidth: Modifier<'sameWidth', Record<string, never>> = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state }) {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect({ state }) {
    const reference = state.elements.reference as HTMLElement;
    const popper = state.elements.popper as HTMLElement;
    popper.style.width = `${reference.offsetWidth}px`;
    return () => {};
  }
};
